import { useNavigate } from 'react-router-dom'

import { Badge } from '@/components/ui/Badge'
import type { DashboardPriorityItemViewModel } from '@/lib/venue/dashboardViewModel'

/**
 * 대시보드 "우선 처리 항목"(`#780` §3, `#782`) — 서버가 내려준 항목만 그린다.
 *
 * 🚨 이 컴포넌트는 빈 배열을 다루지 않는다 — 호출부(`VenueDashboardPage.tsx`)가 빈 배열이면 섹션
 * 전체를 렌더하지 않는다(설계 §2 자율 결정 2, "처리할 것 없음"은 보여줄 정보가 아니다).
 */
export function DashboardPriorityItems({ items }: { items: DashboardPriorityItemViewModel[] }) {
  const navigate = useNavigate()

  return (
    <ul className="divide-y divide-slateish-200">
      {items.map((item) => {
        const path = item.path
        const content = (
          <>
            <div className="min-w-0">
              <p className="font-medium text-ink-700">{item.label}</p>
              <p className="mt-0.5 truncate text-xs text-slateish-600">{item.message}</p>
            </div>
            {item.remainingDaysText ? <Badge tone={item.tone}>{item.remainingDaysText}</Badge> : null}
          </>
        )

        return (
          <li key={item.key}>
            {path ? (
              <button
                type="button"
                onClick={() => {
                  navigate(path)
                }}
                className="flex w-full items-center justify-between gap-3 py-3 text-left text-sm hover:bg-slateish-50"
              >
                {content}
              </button>
            ) : (
              <div className="flex items-center justify-between gap-3 py-3 text-sm">{content}</div>
            )}
          </li>
        )
      })}
    </ul>
  )
}
